var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallHorizontalLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 2,
    viewBox: "0 0 17 2",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.382812 0.570312H16.1859",
    stroke: "#26A677",
    strokeWidth: 1.02545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallHorizontalLine);
export default __webpack_public_path__ + "static/media/smallHorizontalLine.4f69e5cf7927e17bad5a0b8af097e39a.svg";
export { ForwardRef as ReactComponent };